import { render } from "./lingerieConfig.vue?vue&type=template&id=4886fd72&ts=true"
import script from "./lingerieConfig.vue?vue&type=script&lang=ts"
export * from "./lingerieConfig.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__